import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import constantURL from '../../shared/constantURL';
import { BaseLoggedInPostService } from '../../shared/services/base-logged-in-post.service';

@Injectable({
  providedIn: 'root'
})

export class FetchDashboardService extends BaseLoggedInPostService {
  _path = constantURL.dashboard;
  private showAlertFlag: boolean = false;
  private manualPrint = new Subject<boolean>();

  getAlertFlag() {
    return this.showAlertFlag;
  }
  setAlertFlag(flag: boolean) {
    this.showAlertFlag = flag;
  }
  getmanualPrintFlag() {
    return this.manualPrint.asObservable();
  }
  setmanualPrintFlag(flag: boolean) {
    this.manualPrint.next(flag);
  }
}
